/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './AppCopyrightInfo.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type TypeProps = {|
  accountLastSyncMoment?: moment,
|} & TranslatorProps;

function AppCopyrightInfo(props: TypeProps): React.Element<*> {
  const { t }: TypeProps = props;

  let dbLastUpdated = '';

  if (props.accountLastSyncMoment) {
    /** @see momentjs.com/docs/#/displaying/fromnow/ */
    dbLastUpdated =
      ` | ${t('general:database_last_updated')} ` + props.accountLastSyncMoment.fromNow();
  }

  /*eslint max-len: ["error", { "ignoreStrings": true }]*/
  return (
    <p className={styles['app-copyright-info']}>
      &copy; {`${new Date().getFullYear()} ${process.env.REACT_APP_COMPANY_NAME}`}{' '}
      {`Ltd. ${t('general:all_rights_reserved')}`}
      {dbLastUpdated}
    </p>
  );
}

export default translate()(AppCopyrightInfo);
